export class PasswordGenModel {
setValue(res){
if(res){
}
}
}